module.exports = require("././src/select2.js");


//////////////////
// WEBPACK FOOTER
// angular-ui-select2 (bower component)
// module id = 1423
// module chunks = 1